<template>
    <div class="charts">
		<div class="charts__row">
			<chart
				:update="update"
				:updateRight="updateRight"
				:updateHeight="updateHeight"
				:period="'month'"
				:percent="96"
				:title="'1 месяц'"
				:fullStatus="true">
			</chart>
			<chart
				:update="update"
				:updateRight="updateRight"
				:updateHeight="updateHeight"
				:period="'sison'"
				:percent="96"
				:fullStatus="fullStatus"
				:title="'3 месяца'">
			</chart>
		</div>

		<div class="charts__row">
			<chart
				:update="update"
				:updateRight="updateRight"
				:updateHeight="updateHeight"
				:period="'sixmonth'"
				:percent="91"
				:title="'6 месяцев'">
			</chart>
			<chart
				:update="update"
				:updateRight="updateRight"
				:updateHeight="updateHeight"
				:period="'year'"
				:percent="86"
				:title = "'1 год'"
			>
			</chart>
		</div>
    </div>
</template>
<script>
import PrognosisChart from "./sig-profitability-chart-prognosis";
export default {
    components: {
        'chart':PrognosisChart,
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    }
}
</script>
<style lang="less" scoped>
</style>
